import * as React from "react"
import { List } from "immutable"
import { Link } from "./library/link";
import { slugify } from "../../custom_utils/helpers";

export interface BooksBlockProps {
  kind: "books"
  title?: string
  text?: string
  books: List<BookProps>
}

export interface BookProps {
  title: string
  author: string
  imageUrl: string
  imageAlt: string
  url?: string
  className?: string
  heading?: 'h3' | 'h4'
}

export const Book:React.StatelessComponent<BookProps> = p => {
  let content = (p: BookProps) => (
    <>
      <div className="book__caption">
        <span className="book__header title--s">Boekentip</span>
        {p.heading && p.heading == 'h4' ? (
          <h4 data-anchor={slugify(p.title)} className="book__title title--xs"><span>{p.title}</span></h4>
        ) : (
          <h3 data-anchor={slugify(p.title)} className="book__title title--xs"><span>{p.title}</span></h3>
        )}
        
        <p className="book__text"><span>{p.author}</span></p>
      </div>
      <div className="book__visual">
        <img src={p.imageUrl} alt={p.imageAlt} className="book__image" />
      </div>
    </>
  );

  return (
    <article className={`book ${p.className && p.className}`}>
      {p.url && p.url != ""
        ? <Link url={p.url} className="book__inner book__link">
            {content(p)}
          </Link>
        : <div className="book__inner">{content(p)}</div>
      }
    </article>
  )
}

export const BooksBlock: (p: BooksBlockProps) => JSX.Element = p => (
  <aside className="books">
    <header className="books__header">
      {p.title && <h2 className="books__title title--l">{p.title}</h2>}
      {p.text && <p className="books__intro">{p.text}</p>}
    </header>

    {!p.books.isEmpty() && (
      <ul className="books__list">
        {p.books.map((book, k) => (
          <li className="books__item" key={`book-${k}`}>
            <Book {...book} />
          </li>
        ))}
      </ul>
    )}
  </aside>
);
